import { PUBLIC_VOTING_STATUS_ENUM, VOTED_FILTER_ENUM, VOTING_TYPE_ENUM } from "@antipartido-inc/contracts-ifaces"

export default {
  noOpenVotings: "No hay votaciones abiertas",
  status: {
    title: "Estado",
    options: {
      [PUBLIC_VOTING_STATUS_ENUM.UPCOMING]: "Próximamente",
      [PUBLIC_VOTING_STATUS_ENUM.ACTIVE]: "Activo",
      [PUBLIC_VOTING_STATUS_ENUM.CLOSED]: "Finalizado",
    },
  },
  type: {
    title: "Tipo",
    options: {
      [VOTING_TYPE_ENUM.PROPOSAL]: "Propuesta",
      [VOTING_TYPE_ENUM.CANDIDATE]: "Candidato",
    },
  },
  votedFilter: {
    title: "Participación",
    options: {
      [VOTED_FILTER_ENUM.VOTED]: "Votado",
      [VOTED_FILTER_ENUM.NOT_VOTED]: "No votado",
    },
  },
  timeRemaining: {
    finished: "Finalizado",
    startsToday: "Empieza hoy",
    startsIn: "Empieza en {{days}} días",
    endsToday: "Termina hoy",
    endsIn: "Termina en {{days}} días",
  },
  title: "Votaciones",
  welcome: "¡Bienvenido!",
  loading: "Cargando votaciones...",
  votingsDescription: "¡Participa en las decisiones que te afectan!",
  filter: "Filtrar",
  resetFilters: "Restablecer",
  applyFilters: "Aplicar",
  results: "resultados",
  vote: "Votar",
  editVote: "Editar voto",
  viewVoting: "Ver votación",
  voted: "Votado",
  localProposal: "Propuesta Local",
  globalProposal: "Propuesta Global",
  participants: "Votos",
  startsOn: "Comienza el",
  endsOn: "Termina el",
  endsToday: "Termina hoy",
  finishedOn: "Terminado el {{date}}",
  remainingDays: "días restantes",
  startsIn: "Empieza en",
  startsToday: "Empieza hoy",
  days: "días",
  progress: "Tiempo restante",
  loadMore: "Cargar más",
  noVotings: "No hay votaciones que coincidan con los filtros seleccionados",
  citizenId: "CURP",
  myVotings: "Votaciones en las que has participado",
  fewVotingsInfo: {
    title: "¡Ya formas parte del censo!",
    message:
      "A partir de ahora, verás y podrás participar en cada nueva votación en la que estés incluido.",
  },
  subscriptionRequired: {
    title: "¿Por qué no puedo votar?",
    message: "Para poder votar debes estar suscrito",
    button: "SUSCRIBIRME",
  },
  censusCountdown: {
    title: "En 1 minuto podrás ver las votaciones",
    message:
      "Necesitamos 1 minuto para registrarte en el censo a través de la blockchain, una vez estés registrado podrás ver las votaciones. Aprovecha para suscribirte ya que no podrás votar si no estás suscrito.",
    button: "SUSCRIBIRME",
  },
  subscriptionExpiring: {
    title: "Tu suscripción está a punto de caducar",
    message: "Renueva tu suscripción para seguir participando, sinó cuando finalice no podrás seguir votando",
    button: "RENOVAR",
  },
}
